import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { CardElement, injectStripe } from 'react-stripe-elements';
import { reduxForm, Field, startSubmit, getFormValues } from 'redux-form';

import WithUser from 'shared/HOCs/WithUser';

import renderInputField from 'shared/forms/RenderInputField';
import {
  requestChangePlan,
  PAYMENT_FORM_NAME
} from 'shared/components/ChangePlanModal/ducks';
import Button from 'shared/components/Button';
import { GAUpgradeToPremiumPlan } from 'shared/utils/GA';

import './styles.scss';

class PaymentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cardErrorMsg: null
    };

    this.submit = this.submit.bind(this);
  }

  resetCardError = () => {
    this.setState({ cardErrorMsg: null });
  };

  async submit(event) {
    event.preventDefault();
    if (this.props.processingSubscription) return;
    this.props.submitForm(PAYMENT_FORM_NAME);

    const tokenResult = await this.props.stripe.createToken();

    if (!_.isNil(tokenResult.error)) {
      this.setState({ cardErrorMsg: tokenResult.error.message });
      return;
    }

    const submitData = {
      token: tokenResult.token.id,
      ...this.props.formValues
    };

    const extraActions = [() => GAUpgradeToPremiumPlan(this.props.user.id)];
    this.props.requestChangePlan(submitData, extraActions);
  }

  render() {
    return (
      <div className="payment-form-wrapper">
        <form className={classNames('payment-form')} onSubmit={this.submit}>
          {this.state.cardErrorMsg && (
            <div className="error-text">{this.state.cardErrorMsg}</div>
          )}
          <CardElement onChange={this.resetCardError} />
          <Field
            className="StripeElement InputElement"
            name="coupon"
            placeholder="Coupon Code (Optional)"
            component={renderInputField}
            isGeneric={false}
          />

          <div className="pay-btn-wrapper">
            <Button
              color="primary"
              className={classNames('pay-btn', {
                'processing-payment': this.props.processingSubscription
              })}
              disabled={this.props.processingSubscription}
              type="submit">
              {this.props.processingSubscription ? 'Processing' : 'Pay Now'}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { planType, processingSubscription } = state.changePlan;
  const formValues = getFormValues(PAYMENT_FORM_NAME)(state);

  return { planType, processingSubscription, formValues };
};
const mapDispatchToProps = {
  requestChangePlan,
  submitForm: startSubmit
};

PaymentForm = reduxForm({ form: PAYMENT_FORM_NAME })(PaymentForm);

export default WithUser(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectStripe(PaymentForm))
);
